import React from 'react';
import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="not-found-page">
      <div className="not-found-inner">
        <h1>404</h1>
        <p>Diese Seite existiert nicht.</p>
        <Link to="/dashboard" className="btn btn-primary">Zum Dashboard</Link>
      </div>
    </div>
  );
}
